import React, { useContext, useState } from "react";
import MenuItem from "./MenuItem";
import "./menu.scss";
import Icon from "../Icon";
import { Link } from "react-router-dom";
import UserContext from "../../../services/context/userContext";
import { FaBeer, FaToolbox } from "react-icons/fa"
const menuData = require("./data/menu.json");
export default function MainMenu({ active, submenu }) {
  const [showTitles, setShowTitles] = useState(false);

  if (document.getElementsByTagName("body")[0].className.match(/programs/)) {
    active = 'programs';
  }

  const user = useContext(UserContext);
  const isAdmin = user.admin;

  return (
    <nav id="main-menu">
      <div>
        <ul className="main-listmenu">
          {menuData.map((item, index) => {
            switch (item.name) {
              case "dashboard":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="home" item={item} index={index} key={index} /><span title={item.label}>Home</span></div>
              case "exercises":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="exercise" item={item} index={index} key={index} /><span title={item.label}>Exercises</span></div>
              case "workouts":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="activity" item={item} index={index} key={index} /><span title={item.label}>Workouts</span></div>
              case "programs":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="book" item={item} index={index} key={index} /><span title={item.label}>Programs</span></div>
              case "mealplans":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="file-text" item={item} index={index} key={index} /><span title={item.label}>Mealplans</span></div>
              case "forms":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="toggle-left" item={item} index={index} key={index} /><span title={item.label}>Forms</span></div>
              case "clients":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="users" item={item} index={index} key={index} /><span title={item.label}>Clients</span></div>
              
              // case "clientsOverview":
              //   return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="users" item={item} index={index} key={index} /><span title={item.label}>Clients</span></div>
              
                case "toolbox":
                return <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="toolbox" item={item} index={index} key={index} /><span title={item.label}>Toolbox</span></div>
              // return <div key={ index } className="openMenu" active={(active==item.name) ? 'active' : '' } style={{display:"flex",justifyContent:"center",alignItems:"center"}}><FaToolbox size={30}  item={item} index={index} key={index} /><span title={item.label}>ToolBox</span></div>

              case "subs":
                return isAdmin ? <div key={index} className="openMenu" active={(active == item.name) ? 'active' : ''}><MenuItem active={active} icon="lock" item={item} index={index} key={index} /><span title={item.label}>Access</span></div> : <></>
              default:
                break;
            }
          })}
        </ul>
      </div>
    </nav>
  );
}
